import {remove_token} from "./token";
import {redirect_login} from "../routes/Login_Route";

export function logout(){
    if(window.confirm("確定要登出嗎?")){
        remove_token();
        redirect_login();
    }
}